<template>
  <img src="https://js.dingdandao.com/library/cdnImage/common/empty.png" />
</template>

<script lang="ts" setup>
defineOptions({
  name: 'ImgEmpty',
})
</script>
